import React from 'react';
import { Card, Select, Table, Tag, Button } from 'antd';

interface Props {
  historyItems: any[];
  historyLoading: boolean;
  formValues: any;
  onChangeCampaignType: (v: string) => void;
  loadHistory: (force?: boolean) => void;
  downloadDeliveryReport: (item: any) => void;
  canDownload?: boolean;
}

const ActiveCampaignHistory: React.FC<Props> = ({ historyItems, historyLoading, formValues, onChangeCampaignType, loadHistory, downloadDeliveryReport, canDownload }) => {
  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name', render: (v: string) => <span>{v}</span> },
    { title: 'Status', dataIndex: 'campaignStatus', key: 'campaignStatus', render: (s: string) => <Tag>{s}</Tag> },
    { title: 'Scheduled', dataIndex: 'scheduled', key: 'scheduled', render: (s: string) => s ? new Date(s).toLocaleString() : 'Sem agendamento' },
    { title: 'Created', dataIndex: 'created', key: 'created', render: (c: string) => c ? new Date(c).toLocaleString() : '' },
    { title: 'Totals', key: 'totals', render: (_: any, r: any) => (
        <div>
          <div>Total: {r.total}</div>
          <div>Processed: {r.processed}</div>
          <div>Received: {r.received}</div>
          <div>Read: {r.read}</div>
          <div>Replied: {r.replied}</div>
          <div>Failed: {r.failed}</div>
          <div className="mt2">
            {(() => {
              const failures = r && (r.failed || r.Failed || r.failedCount || r.failed_count || 0);
              if (!failures || Number(failures) <= 0) return null;
              return (
                <Button type="primary" size="small" onClick={() => downloadDeliveryReport(r)} disabled={!canDownload}>
                  Download failed report
                </Button>
              );
            })()}
          </div>
        </div>
      )
    }
  ];

  return (
    <Card title="Recent Campaigns" extra={<a onClick={() => loadHistory(true)}>Refresh</a>}>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: 12, minWidth: 110, fontWeight: 600, color: '#222' }}>Campaign Type:</div>
        <div style={{ background: '#fff', border: '1px solid #e8e8e8', padding: '6px 8px', borderRadius: 4 }}>
          <Select value={formValues.campaignType} onChange={(v: string) => onChangeCampaignType(v)} style={{ width: 160 }}>
            <Select.Option value="batch">Batch</Select.Option>
            <Select.Option value="individual">Individual</Select.Option>
          </Select>
        </div>
      </div>

      <Table
        loading={historyLoading}
        dataSource={historyItems}
        rowKey="id"
        pagination={false}
        columns={columns}
      />
    </Card>
  );
};

export default ActiveCampaignHistory;
